import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";
import { styled } from '@mui/material';

const Styled = {};

Styled.ButtonContainer = styled("div")(({ type, buttontheme, disabled }) => {
    let background = ColorSAP.neutral[70];
    let borderColor = ColorSAP.neutral[70];
    let color = ColorSAP.neutral[0];
    let backgroundArrow = ColorSAP.neutral[50];
    let borderColorArrow = ColorSAP.neutral[50];


    if (type === "primary") {
        if (buttontheme === "dark") {
            background = ColorSAP.neutral[70];
            borderColor = ColorSAP.neutral[70];
            color = ColorSAP.neutral[0];

            backgroundArrow = ColorSAP.neutral[50];
            borderColorArrow = ColorSAP.neutral[50];
        } else if (buttontheme === "light") {
            background = ColorSAP.neutral[20];
            borderColor = ColorSAP.neutral[20];
            color = ColorSAP.neutral[100];

            backgroundArrow = ColorSAP.neutral[15];
            borderColorArrow = ColorSAP.neutral[15];
        } else if (buttontheme === "danger") {
            background = ColorSAP.danger[40];
            borderColor = ColorSAP.danger[40];
            color = ColorSAP.neutral[0];

            backgroundArrow = ColorSAP.danger[30];
            borderColorArrow = ColorSAP.danger[30];
        }
    } else if (type === "secondary") {
        if (buttontheme === "dark") {
            background = ColorSAP.neutral[15];
            borderColor = ColorSAP.neutral[70];
            color = ColorSAP.neutral[100];

            backgroundArrow = ColorSAP.neutral[20];
            borderColorArrow = ColorSAP.neutral[20];
        } else if (buttontheme === "light") {
            background = ColorSAP.neutral[80];
            borderColor = ColorSAP.neutral[0];
            color = ColorSAP.neutral[0];

            backgroundArrow = ColorSAP.neutral[70];
            borderColorArrow = ColorSAP.neutral[70];
        }
    } else {
        if (buttontheme === "danger") {
            background = "#F16158";
            color = ColorSAP.neutral[0]
            borderColor = "#F16158";
            borderColorArrow = "#F4807A";
            backgroundArrow = "#F4807A";
        }
    }

    return (!disabled ? {
        '&:hover': {
            background,
            color,
            borderColor,

            '& .arrowContainer': {
                background: backgroundArrow,
                borderColor: borderColorArrow
            },
        },
    } : {})
});

Styled.Button = styled(Styled.ButtonContainer)(({ type, size, buttontheme, disabled }) => {
    let background = "transparent";
    let borderColor = ColorSAP.neutral[90];
    let color = ColorSAP.neutral[100]

    if (type === "primary") {
        if (buttontheme === "dark") {
            if (disabled) {
                background = ColorSAP.neutral[30];
                borderColor = ColorSAP.neutral[30];
                color = ColorSAP.neutral[20];
            } else {
                background = ColorSAP.neutral[90];
                borderColor = ColorSAP.neutral[90];
                color = ColorSAP.neutral[0];
            }
        } else if (buttontheme === "light") {
            if (disabled) {
                background = ColorSAP.neutral[40];
                borderColor = ColorSAP.neutral[40];
                color = ColorSAP.neutral[20];
            } else {
                background = ColorSAP.neutral[0];
                borderColor = ColorSAP.neutral[0];
                color = ColorSAP.neutral[100];
            }
        } else if (buttontheme === "danger") {
            if (disabled) {
                background = ColorSAP.neutral[40];
                borderColor = ColorSAP.neutral[40];
                color = ColorSAP.neutral[20];
            } else {
                background = ColorSAP.danger[50];
                borderColor = ColorSAP.danger[50];
                color = ColorSAP.neutral[0];
            }
        }
    } else if (type === "secondary") {
        background = "transparent";

        if (buttontheme === "dark") {
            if (disabled) {
                borderColor = ColorSAP.neutral[30];
                color = ColorSAP.neutral[20];
            } else {
                borderColor = ColorSAP.neutral[90];
                color = ColorSAP.neutral[100];
            }
        } else if (buttontheme === "light") {
            if (disabled) {
                borderColor = ColorSAP.neutral[50];
                color = ColorSAP.neutral[40];
            } else {
                borderColor = ColorSAP.neutral[0];
                color = ColorSAP.neutral[0];
            }
        }
    } else {
        if (buttontheme === "danger") {
            if (disabled) {
                background = ColorSAP.neutral[30];
                borderColor = ColorSAP.neutral[30];
                color = ColorSAP.neutral[20];
            } else {
                background = "#EE4137";
                color = ColorSAP.neutral[0]
                borderColor = "#EE4137";
            }
        }
    }


    return ({
        border: '2px solid',

        height: size === "small" ? 24 : size === "medium" ? 36 : 72,
        padding: size === "small" ? '8px 12px 8px 12px' : size === "medium" ? '16px 24px 16px 24px' : '24px 40px 24px 40px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 100,
        width: 'fit-content',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD,
        userSelect: 'none',
        fontSize: size === "small" ? 12 : size === "medium" ? 18 : 24,

        transition: 'background 300ms ease',

        background,
        color,
        borderColor
    })
})

Styled.ArrowContainer = styled("div")(({ type, size, buttontheme, disabled }) => {
    let background = "transparent";
    let border = "none";
    let color = ColorSAP.neutral[80]

    if (type === "primary") {
        if (buttontheme === "dark") {
            if (disabled) {
                background = ColorSAP.neutral[40];
                border = `2px ${ColorSAP.neutral[40]} solid`;
                color = ColorSAP.neutral[20];
            } else {
                background = ColorSAP.neutral[70];
                border = `2px ${ColorSAP.neutral[70]} solid`;
                color = ColorSAP.neutral[15];
            }
        } else if (buttontheme === "light") {
            if (disabled) {
                background = ColorSAP.neutral[30];
                border = `2px ${ColorSAP.neutral[30]} solid`;
                color = ColorSAP.neutral[20];
            } else {
                background = ColorSAP.neutral[15];
                border = `2px ${ColorSAP.neutral[15]} solid`;
                color = ColorSAP.neutral[80];
            }
        } else if (buttontheme === "danger") {
            if (disabled) {
                background = ColorSAP.neutral[30];
                border = `2px ${ColorSAP.neutral[30]} solid`;
                color = ColorSAP.neutral[20];
            } else {
                background = ColorSAP.danger[40];
                border = `2px ${ColorSAP.danger[40]} solid`;
                color = ColorSAP.neutral[0];
            }
        }
    } else if (type === "secondary") {
        background = "transparent";

        if (buttontheme === "dark") {
            if (disabled) {
                border = `2px ${ColorSAP.neutral[30]} solid`;
                color = ColorSAP.neutral[20];
            } else {
                border = `2px ${ColorSAP.neutral[70]} solid`;
                color = ColorSAP.neutral[80];
            }
        } else if (buttontheme === "light") {
            if (disabled) {
                border = `2px ${ColorSAP.neutral[50]} solid`;
                color = ColorSAP.neutral[40];
            } else {
                border = `2px ${ColorSAP.neutral[15]} solid`;
                color = ColorSAP.neutral[15];
            }
        }
    } else {
        if (buttontheme === "danger") {
            if (disabled) {
                background = ColorSAP.neutral[40];
                color = ColorSAP.neutral[20];
                border = ColorSAP.neutral[40];
            } else {
                background = "#F16158";
                color = ColorSAP.neutral[15];
                border = `2px #F16158 solid`;
            }
        }
    }

    return ({
        transition: 'background 300ms ease',
        background,
        color,
        border,

        display: 'flex',
        width: size === "small" ? 20 : size === "medium" ? 28 : 50,
        height: size === "small" ? 20 : size === "medium" ? 28 : 50,
        padding: size === "small" ? 4 : size === "medium" ? 6 : 11,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 100,
        marginLeft: size === "small" ? 8 : size === "medium" ? 24 : 40,
        "& svg": {
            width: size === "small" ? 14 : size === "medium" ? 20 : 36,
            height: size === "small" ? 14 : size === "medium" ? 20 : 36
        }
    })
});

export default Styled;